<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-select
                    @change="handleFilter"
                    v-model="listQuery.entity.shopParam.shopId"
                    filterable
                    clearable
                    placeholder="请选择店铺"
            >
                <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
         <!--   <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="店铺id"
                      v-model="listQuery.entity.shopParam.shopId">
            </el-input>-->
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="发布素材奖励优惠券"
                      v-model="listQuery.entity.shopParam.couponReward">
            </el-input>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" type="primary" @click="open"
                           v-if="canSave" icon="el-icon-edit">奖励优惠券
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.shopParam.id}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="店铺">
                <template slot-scope="scope">
                    <span v-if="scope.row.shopParam">{{scope.row.shopParam.shopName?scope.row.shopParam.shopName : "社集优选自营店"}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="发布素材奖励优惠券">
                <template slot-scope="scope">
                    <span v-if="scope.row.shopParam">{{scope.row.shopParam.couponReward}}</span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="店铺" prop="material.shopId">
                    <el-select
                            v-model="temp.shopParam.shopId"
                            filterable
                            placeholder="请选择店铺"
                    >
                        <el-option
                                v-for="item in shopList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <!--                    <el-input v-model="temp.material.shopId"></el-input>-->
                </el-form-item>
                <el-form-item label="发布素材奖励优惠券" prop="shopParam.couponReward">
                    <el-input v-model="temp.shopParam.couponReward"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, down, info, save, update, remove,updateMaterialPrice,findShop} from '@/api/shop_param'
    import waves from '@/directive/waves' // 水波纹指令
    import {downExcel} from '@/utils/down.js'


    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                shopList: [],
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'shopParam.id desc',
                    entity: {
                        shopParam:
                            {
                                id: null, shopId: null, couponReward: null
                            }
                    }
                },
                temp: {

                    shopParam:
                        {
                            id: null, shopId: null, couponReward: null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                rules:
                    {
                        'shopParam.shopId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'shopParam.couponReward': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'shop:param:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'shop:param:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'shop:param:update')
            },
            canList() {
                return hasAuth(this.perms, 'shop:param:list')
            }
        },
        methods: {
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
                let query = {status:1,page:1,limit:10000}
                findShop(query).then(res =>{
                    this.shopList=res.data.list
                    this.shopList.unshift({id:0,name:"社集优选自营店"})
                })
            },
            getOptions() {
                options().then(res => {
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片

            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
            },
            resetTemp(row) {

                this.temp = {
                    shopParam: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.shopParam.id]
                const ids = [this.list[this.index].shopParam.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.shopParam.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                this.dialogFormVisible = false
            },
            open() {
                this.$prompt('请输入所有店铺统一优惠券额度', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    updateMaterialPrice(value).then(res => {
                        this.getList()
                        this.$message({
                            type: 'success',
                            message: '设置成功'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
        }
    }
</script>
